import CryptoJS from 'crypto-js'

// ─── 固定 key 的旧版加解密（保持向后兼容） ───────────────────────────────
const THEKEYWORD = 2
const ka = '4de357c200037e9feb1c82c3d70caeba01'
const kb = ka.split('').reverse().join('').slice(THEKEYWORD)
const _fixedKey = CryptoJS.enc.Utf8.parse(kb)
const _fixedIv  = CryptoJS.enc.Utf8.parse('3c28c1bef9e73000')

export function encrypt(word) {
  let encrypted = ''
  const data = typeof word === 'object' ? JSON.stringify(word) : word
  const srcs  = CryptoJS.enc.Utf8.parse(data)
  encrypted = CryptoJS.AES.encrypt(srcs, _fixedKey, {
    iv: _fixedIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString()
}

export function decrypt(word) {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  const srcs    = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const dec     = CryptoJS.AES.decrypt(srcs, _fixedKey, {
    iv: _fixedIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return dec.toString(CryptoJS.enc.Utf8)
}

// ─── 动态 key/iv 版本（用于请求体加密 / 响应体解密） ─────────────────────

/**
 * MD5 签名，返回小写 hex 字符串
 */
export function signMd5(str) {
  return CryptoJS.MD5(String(str)).toString()
}

/**
 * AES-CBC 加密（动态 key/iv，Base64 输出）
 * @param {string} data  明文字符串
 * @param {string} key   16 位密钥字符串
 * @param {string} iv    16 位向量字符串
 * @returns {string} Base64 密文
 */
export function encryptionCBC(data, key, iv) {
  const k = CryptoJS.enc.Utf8.parse(key)
  const i = CryptoJS.enc.Utf8.parse(iv)
  return CryptoJS.AES.encrypt(data, k, {
    iv: i,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

/**
 * AES-CBC 解密（动态 key/iv，Base64 输入）
 * @param {string} data  Base64 密文
 * @param {string} key   16 位密钥字符串
 * @param {string} iv    16 位向量字符串
 * @returns {string} 明文字符串
 */
export function decryptionCBC(data, key, iv) {
  if (!data) return ''
  const k = CryptoJS.enc.Utf8.parse(key)
  const i = CryptoJS.enc.Utf8.parse(iv)
  return CryptoJS.AES.decrypt(data, k, {
    iv: i,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8)
}